import { autoinject, bindable } from 'aurelia-framework';
import { ServiceStructureService } from "../service-structure-service";
import { NodeModel } from "../../../models/node-model";
import { NotificationType, ResourcedNotificationService } from "../../../components/notifications/notification-service";

@autoinject
export class DeleteService {
	@bindable structureId: string;
	@bindable service: NodeModel;

	serviceDeletionAllowed: boolean;
	confirmDeletion: boolean;
	deletingServices: boolean;
	invalidServiceName: boolean;
	confirmServiceName: string;

	checkingServiceDeletion: boolean = false;

	constructor(
		private element: Element,
		private serviceStructureService: ServiceStructureService,
		private notificationService: ResourcedNotificationService) {
		this.confirmDeletion = false;
		this.serviceDeletionAllowed = null;
		this.deletingServices = false;
		this.invalidServiceName = false;
	}		

	async serviceChanged() {
		this.serviceDeletionAllowed = null;
		this.confirmDeletion = false;

		if (this.service) {
			if (this.service.nodeType === ServiceStructureService.ServiceStructureNodeType) {
				this.serviceDeletionAllowed = false;
			} else {
				this.checkingServiceDeletion = true;
				this.serviceDeletionAllowed = await this.serviceStructureService.isServiceDeletionAllowed(this.service.id);
			}			
		}
		this.checkingServiceDeletion = false;		
	}

	deleteClicked() {
		this.confirmDeletion = true;
	}

	whenDeleted() {
		this.deletingServices = false;
		this.confirmDeletion = false;
		this.confirmServiceName = "";

		this.element.dispatchEvent(new CustomEvent('service-deleted', { bubbles: true, detail: { deletedService: this.service } }));
		this.notificationService.push("Service_DeleteService_Label_DeletionSuccess", NotificationType.Success, null, [this.service.title]);
	}

	confirmDeletionClicked() {
		if (this.confirmServiceName === this.service.title) {
			this.deletingServices = true;
			this.invalidServiceName = false;
			this.serviceStructureService.deleteService(this.service.id)
				.then(this.whenDeleted.bind(this));
		} else {
			this.invalidServiceName = true;
		}
	}
}
